import React, { useState, useLayoutEffect } from "react"
import { animateScroll } from "react-scroll"

import * as s from "./ChildHeader.module.scss"

import { Cta } from "@components/common/cta/Cta"
import { Video } from "@components/common/video/Video"

export const ChildHeader = ({ data }) => {
  const { blocks, blurb, links, title, innerBlock, scrollText } = data
  const hasMedia = blocks && blocks[0] && (blocks[0].image || blocks[0].video)
  const backgroundColor = data.backgroundColor ? data.backgroundColor : ""
  const [loaded, setLoaded] = useState(false)

  const colorClass = backgroundColor => {
    switch (backgroundColor) {
      case "black":
        return s.ChildHeader__black
        break
      case "red":
        return s.ChildHeader__red
        break
      case "yellow":
        return s.ChildHeader__yellow
        break
      case "burgundy":
        return s.ChildHeader__burgundy
        break
      case "navy":
        return s.ChildHeader__navy
        break
      default:
        return s.ChildHeader__red
    }
  }

  useLayoutEffect(() => {
    setLoaded(true)
  }, [])

  return (
    <div
      className={`
    ${s.ChildHeader}
    ${hasMedia && s.ChildHeader___hasBlock}
    ${!hasMedia && s.ChildHeader___hasNoBlock}
    ${colorClass(backgroundColor)}
    `}
    >
      <div className={s.Inner}>
        <div className={s.ChildHeader__row}>
          <div className={s.ChildHeader__title}>
            <h1 dangerouslySetInnerHTML={{ __html: title }} />
          </div>

          <div>
            <div className={s.ChildHeader__blurb}>
              <p dangerouslySetInnerHTML={{ __html: blurb }} />
            </div>

            <div className={s.ChildHeader__links}>
              <Cta
                title={scrollText}
                onClick={() => {
                  animateScroll.scrollMore(window.innerHeight * 0.95)
                }}
              />

              {links &&
                links[0].link &&
                links.map((item, i) => {
                  return (
                    <Cta
                      key={i}
                      title={item.link.title}
                      link={item.link.url}
                      target={item.link.target}
                      external={item.link.target === "_blank"}
                    />
                  )
                })}
            </div>
          </div>
        </div>

        {hasMedia && (
          <div className={s.Block}>
            <div
              className={`${s.Block__cover} ${
                loaded && s.Block__cover___cleared
              }`}
            />

            {blocks[0].type === "image" && blocks[0].image && (
              <div
                className={`${s.Block__block} ${s.Block__block___image}`}
                style={{
                  background: `url(${blocks[0].image.sourceUrl})`,
                }}
              >
                {innerBlock && innerBlock[0] && innerBlock[0].content && (
                  <div
                    className={`${s.Block__innerBlock}`}
                    style={{
                      background: innerBlock[0].color,
                    }}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: innerBlock[0].content,
                      }}
                    />
                  </div>
                )}
              </div>
            )}

            {blocks[0].type === "video" &&
              (blocks[0].videoUrl || blocks[0].videoFile.sourceUrl) && (
                <div className={`${s.Block__block} ${s.Block__block___video}`}>
                  <Video
                    url={blocks[0].videoUrl || blocks[0].videoFile.sourceUrl}
                    cover={true}
                  />

                  {innerBlock && innerBlock[0] && innerBlock[0].content && (
                    <div
                      className={`${s.Block__innerBlock}`}
                      style={{
                        background: innerBlock[0].color,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{
                          __html: innerBlock[0].content,
                        }}
                      />
                    </div>
                  )}
                </div>
              )}
          </div>
        )}
      </div>
    </div>
  )
}
